import { IconProps } from "./types";

export const Google = ({ style }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M19.1663 10.3998C19.1663 9.76408 19.1148 9.12497 19.0048 8.4996H10.1844V12.1006H15.2354C15.0258 13.262 14.3524 14.2894 13.3662 14.9423V17.2788H16.3797C18.1493 15.6501 19.1663 13.2449 19.1663 10.3998Z"
        fill="#4285F4"
      />
      <path
        d="M10.1844 19.5363C12.7064 19.5363 14.8334 18.7082 16.3831 17.2788L13.3696 14.9423C12.5312 15.5127 11.4488 15.8357 10.1878 15.8357C7.74816 15.8357 5.67962 14.1898 4.93742 11.9769H1.82775V14.3856C3.41523 17.5434 6.6486 19.5363 10.1844 19.5363Z"
        fill="#34A853"
      />
      <path
        d="M4.934 11.9769C4.54228 10.8155 4.54228 9.55791 4.934 8.3965V5.9878H1.82776C0.501429 8.63016 0.501419 11.7433 1.82775 14.3856L4.934 11.9769Z"
        fill="#FBBC04"
      />
      <path
        d="M10.1843 4.53432C11.5176 4.5137 12.8061 5.01537 13.7716 5.93625L16.4415 3.2664C14.7509 1.67892 12.5072 0.806149 10.1843 0.833638C6.6486 0.833638 3.41524 2.82659 1.82776 5.9878L4.934 8.3965C5.67276 6.18022 7.74472 4.53432 10.1843 4.53432Z"
        fill="#EA4335"
      />
    </svg>
  );
};
